var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{close:_vm.closeBurgerMenu},attrs:{"id":"burger-menu"},on:{"click":_vm.toggleBurger}},[_c('span'),_c('span'),_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }